import React from "react";
import { Accordion } from "react-bootstrap";
import SettingsTabIcon1 from "assets/images/SettingsTabIcon1.png";
import SettingsTabIcon2 from "assets/images/SettingsTabIcon2.png";
import SettingsTabIcon3 from "assets/icons/settings/clickCard.svg";
import OneClickSelect from "assets/icons/settings/one_click_select.svg";
import TwoClickSelect from "assets/icons/settings/two_click_select.svg";
import MuteIcon from "assets/images/mute-icon.svg";
import SoundIcon from "assets/images/sound-icon.svg";
import SettingsItem from "../SettingsItem";
import { SettingState } from "types/user";
import RadioButton from "common/components/RadioButton";
import Button from "common/components/Button";

interface Props {
  settings?: Partial<SettingState>;
  onChangeSetting?: (
    type: "card_display" | "card_bidding" | "background_color" | "sound_site" | "double_click_card",
    value: {
      type: any;
    }
  ) => void;
  onSubmit?: () => void;
}

const SettingsMobileTab = ({ settings, onSubmit, onChangeSetting }: Props) => {
  console.log("settings.fonColor", settings.fonColor);
  return (
    <div className="settingsTab-main-mobile">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header className="settingsTab-accordion-header">
            <div className="settingsTab-accordion-header-img-wrapper">
              <div className="settingsTab-accordion-header-img-container">
                <img src={SettingsTabIcon1} className="settingsTab-accordion-header-img" />
              </div>
            </div>
            <span>צלילים</span>
          </Accordion.Header>
          <Accordion.Body className="settingsTab-accordion-body">
            <SettingsItem
              img={SoundIcon}
              label="הפעל צלילים"
              isActive={settings.sound}
              onClick={() => onChangeSetting && onChangeSetting("sound_site", { type: true })}
            />
            <SettingsItem
              img={MuteIcon}
              label="השתק צלילים"
              isActive={!settings.sound}
              backgroudContainer="#fff"
              backgroudWrapper="#481EA0"
              colorText="#382956"
              style={{ marginTop: 16 }}
              onClick={() => onChangeSetting && onChangeSetting("sound_site", { type: false })}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header className="settingsTab-accordion-header">
            <div className="settingsTab-accordion-header-img-wrapper">
              <div className="settingsTab-accordion-header-img-container">
                <img src={SettingsTabIcon2} className="settingsTab-accordion-header-img" />
              </div>
            </div>
            <span>צבע רקע</span>
          </Accordion.Header>
          <Accordion.Body className="settingsTab-accordion-body">
            <div
              className="fon-setting-item-wrapper"
              onClick={() =>
                onChangeSetting && onChangeSetting("background_color", { type: "blue" })
              }>
              <RadioButton active={settings.fonColor === "blue"} />
              <div className="fon-setting-item-container"></div>
            </div>
            <div
              className="fon-setting-item-wrapper"
              onClick={() =>
                onChangeSetting && onChangeSetting("background_color", { type: "white_blue" })
              }>
              <RadioButton active={settings.fonColor === "white_blue"} />
              <div className="fon-setting-item-container-border">
                <div className="fon-setting-item-container"></div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header className="settingsTab-accordion-header">
            <div className="settingsTab-accordion-header-img-wrapper">
              <div className="settingsTab-accordion-header-img-container">
                <img src={SettingsTabIcon3} className="settingsTab-accordion-header-img" />
              </div>
            </div>
            <span>לחיצה על קלף</span>
          </Accordion.Header>
          <Accordion.Body className="settingsTab-accordion-body">
            <SettingsItem
              img={OneClickSelect}
              label="משחק מידי"
              isActive={!settings.playCardDblClick}
              onClick={() =>
                onChangeSetting && onChangeSetting("double_click_card", { type: false })
              }
            />
            <SettingsItem
              img={TwoClickSelect}
              label="הגדלת סדרה"
              isActive={settings.playCardDblClick}
              backgroudContainer="#fff"
              backgroudWrapper="#481EA0"
              colorText="#382956"
              style={{ marginTop: 16 }}
              onClick={() =>
                onChangeSetting && onChangeSetting("double_click_card", { type: true })
              }
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <div className="settings-tab-btn-wrapper">
        <Button text="שמור שינויים" onClick={onSubmit} />
      </div>
    </div>
  );
};

export default SettingsMobileTab;
